var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.displayCurrency)+" "+_vm._s(_vm.price)),(_vm.priceAdjust)?_c('span',{staticClass:"caption"},[_c('span',[_vm._v(_vm._s(_vm.priceAdjust > 0 ? ("+" + _vm.priceAdjust) : _vm.priceAdjust))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }